
import { Component, Prop, Vue } from "vue-property-decorator";
import PortfolioPositionsTopFlop from "@/components/PortfolioPositionsTopFlop.vue";

@Component({
  name: "Portfolio",
  components: { PortfolioPositionsTopFlop },
})
export default class Portfolio extends Vue {
  @Prop({ type: String, required: false, default: "de" })
  private readonly locale!: string;

  @Prop({ type: String, required: false })
  private readonly defaultId!: string;

  @Prop({ type: Object, required: false })
  private readonly additionalNewsCriteria!: Record<string, unknown>;

  @Prop({ type: Number, required: false, default: 5 })
  private readonly newsArticleItemsPerPage!: number;

  @Prop({ type: Number, required: false, default: 5 })
  private readonly positionItemsPerPage!: number;

  @Prop({ type: Number, required: false, default: 10 })
  private readonly transactionItemsPerPage!: number;

  @Prop({ type: Number, required: false, default: 3 })
  private readonly topFlopMaxItems!: number;

  @Prop({
    type: Array,
    required: false,
    default: () => [
      { key: "overview", label: "portfolio.tab.overview" },
      { key: "positions", label: "portfolio.tab.positions" },
      { key: "transactions", label: "portfolio.tab.transactions" },
      { key: "news", label: "portfolio.tab.news" },
    ],
  })
  private readonly tabs!: Array<object>;

  private topFlopId!: string;

  public onPositionsListTableRowClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("portfolio-positions-list-table-row-clicked", {
        detail: payload,
      })
    );
  }
  public onOverviewPositionsTableRowClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("portfolio-overview-positions-table-row-clicked", {
        detail: payload,
      })
    );
  }
  public onTransactionsListTableRowClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("portfolio-transactions-list-table-row-clicked", {
        detail: payload,
      })
    );
  }
  public onNewsListTableRowClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("portfolio-news-list-table-row-clicked", {
        detail: payload,
      })
    );
  }
  public onPortfolioChange(payload: string) {
    this.topFlopId = payload;
    window.dispatchEvent(
      new CustomEvent("portfolio-changed", {
        detail: payload,
      })
    );
  }
  mounted() {
    this.topFlopId = this.defaultId;
  }
}
